import { useState } from "react";

/**
 * 研究中心相关状态管理 Hook
 */
const useResearchCenterState = () => {
  const [researchCenterOpen, setResearchCenterOpen] = useState(false);
  const [researchTasks, setResearchTasks] = useState([]);
  const [unreadResearchCount, setUnreadResearchCount] = useState(0);
  const [achievementWallData, setAchievementWallData] = useState(null);
  const [profileHistoryData, setProfileHistoryData] = useState(null);
  const [leaderboardData, setLeaderboardData] = useState(null);
  const [skillHistoryData, setSkillHistoryData] = useState(null);
  const [growthMapData, setGrowthMapData] = useState(null);

  // 批量更新研究中心状态
  const updateResearchCenterState = (data) => {
    if (data.isOpen !== undefined) setResearchCenterOpen(data.isOpen);
    if (data.tasks !== undefined) setResearchTasks(data.tasks);
    if (data.unreadCount !== undefined) setUnreadResearchCount(data.unreadCount);
    if (data.achievementWall !== undefined) setAchievementWallData(data.achievementWall);
    if (data.profileHistory !== undefined) setProfileHistoryData(data.profileHistory);
    if (data.leaderboard !== undefined) setLeaderboardData(data.leaderboard);
    if (data.skillHistory !== undefined) setSkillHistoryData(data.skillHistory);
    if (data.growthMap !== undefined) setGrowthMapData(data.growthMap);
  };

  // 重置研究中心状态
  const resetResearchCenterState = () => {
    setResearchCenterOpen(false);
    setResearchTasks([]);
    setUnreadResearchCount(0);
    setAchievementWallData(null);
    setProfileHistoryData(null);
    setLeaderboardData(null);
    setSkillHistoryData(null);
    setGrowthMapData(null);
  };

  return {
    researchCenterOpen,
    setResearchCenterOpen,
    researchTasks,
    setResearchTasks,
    unreadResearchCount,
    setUnreadResearchCount,
    achievementWallData,
    setAchievementWallData,
    profileHistoryData,
    setProfileHistoryData,
    leaderboardData,
    setLeaderboardData,
    skillHistoryData,
    setSkillHistoryData,
    growthMapData,
    setGrowthMapData,
    updateResearchCenterState,
    resetResearchCenterState,
  };
};

export default useResearchCenterState;
